// extracted by mini-css-extract-plugin
export default {"wrapper":"EditCompetitorsModalTable_wrapper__KLKEh","table":"EditCompetitorsModalTable_table__UV0VB","pagination":"EditCompetitorsModalTable_pagination__0J+4F"};